import LogToast from "./LogToast";

export default LogToast;
